import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "edunation-cookie-consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(KEY);
            if (v === "granted") {
                if (window.__enableMetaPixel) window.__enableMetaPixel();
            } else if (!v) {
                setVisible(true);
            }
        } catch (e) {
            setVisible(true);
        }
    }, []);

    const choose = (granted) => {
        try {
            localStorage.setItem(KEY, granted ? "granted" : "denied");
        } catch (e) {}
        if (granted && window.__enableMetaPixel) window.__enableMetaPixel();
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-4 inset-x-4 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md z-[100]"
                    data-testid="cookie-banner"
                    role="dialog"
                    aria-label="Zgoda na pliki cookie"
                >
                    <div className="rounded-3xl bg-white border border-brand-tint2 shadow-[0_30px_70px_-25px_rgba(35,38,43,0.5)] p-6">
                        <h2 className="text-base font-extrabold text-brand-ink">Szanujemy Twoją prywatność</h2>
                        <p className="mt-2 text-sm leading-relaxed text-brand-gray">
                            Używamy plików cookie i podobnych technologii (w tym piksela Facebooka) do celów
                            analitycznych i marketingowych. Szczegóły znajdziesz w{" "}
                            <a
                                href="https://edunation.com.pl/polityka-prywatnosci/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-semibold text-brand-deep underline underline-offset-2 hover:text-brand"
                                data-testid="cookie-privacy-link"
                            >
                                polityce prywatności
                            </a>
                            .
                        </p>
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                            <button
                                type="button"
                                onClick={() => choose(true)}
                                data-testid="cookie-accept-button"
                                className="rounded-full bg-brand-deep px-6 py-3 text-sm font-extrabold text-white shadow-[0_12px_28px_-12px_rgba(196,0,111,0.7)] transition-[transform,background-color] duration-200 hover:bg-brand hover:scale-[1.02] active:scale-[0.98]"
                            >
                                Akceptuję
                            </button>
                            <button
                                type="button"
                                onClick={() => choose(false)}
                                data-testid="cookie-reject-button"
                                className="rounded-full border-2 border-brand-tint2 px-6 py-3 text-sm font-bold text-brand-ink transition-colors duration-200 hover:border-brand"
                            >
                                Tylko niezbędne
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
